import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { HippoLoadingService } from '@hippo/services/loading/loading.service';
import { finalize, Observable, take } from 'rxjs';

export const hippoLoadingInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const hippoLoadingService = inject(HippoLoadingService);
    let handleRequestsAutomatically = false;

    hippoLoadingService.auto$.pipe(take(1)).subscribe(value => {
        handleRequestsAutomatically = value;
    });

    // If the Auto mode is turned off, do nothing
    if (!handleRequestsAutomatically) {
        return next(req);
    }

    // Set the loading status to true
    hippoLoadingService._setLoadingStatus(true, req.url);

    return next(req).pipe(
        finalize(() => {
            // Set the status to false if there are any errors or the request is completed
            hippoLoadingService._setLoadingStatus(false, req.url);
        })
    );
};
